import React, { useState, useEffect, useCallback } from "react";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";

import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import { Container } from "./styles";
import Modal from "react-modal";

import { Table } from "semantic-ui-react";
import swal from "sweetalert";
import { producaov2 as api } from "../../../services/apis";

import Loader from "../../../components/Loader";
import Loading from "../../../components/Loading";

const AmeConciliacao = () => {
  const [ordersSets, setOrdersSets] = useState({
    vendas: {
      ordens: [],
      total: {
        bruto: 0,
        liquido: 0,
      },
    },
    retiradas: {
      ordens: [],
      total: {
        bruto: 0,
        liquido: 0,
      },
    },
    estornos: {
      ordens: [],
      total: {
        bruto: 0,
        liquido: 0,
      },
    },
    financeiro: {
      ordens: [],
      total: {
        bruto: 0,
        liquido: 0,
      },
    },
  });

  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(
    (new Date().getMonth() + 1 < 10 ? "0" : "") + (new Date().getMonth() + 1)
  );
  const [loading, setLoading] = useState(true);
  const [loadingRelatory, setLoadingRelatory] = useState(false);

  const metodosPagamento = {
    CREDIT_CARD: "Cartão de Crédito",
    CASH: "Dinheiro",
    BANK_TRANSFER: "Transferência Bancária",
  };

  const [aba, setAba] = useState("financeiro");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeOrdem, setActiveOrdem] = useState({
    data: null,
    index: -1,
  });
  const [relatoryUrl, setRelatoryUrl] = useState("");

  const tabs = {
    financeiro: "Recebimentos",
    retiradas: "Retiradas",
    vendas: "Vendas",
    estornos: "Estornos",
  };

  const abasOptions = Object.keys(tabs);

  const handleChangeAba = (index) => {
    setAba(abasOptions[index]);
    setActiveOrdem({
      data: null,
      index: -1,
    });
  };

  const getRecebimentoOrders = async (date) => {
    try {
      const params = {
        date,
      };

      const response = await api.get("admin/ame/conciliation/cashout", { params });

      return response.data.retiradas.recebimentoOrders;
    } catch (err) {
      console.error(err);

      return [];
    }
  };

  const handleOrderSet = useCallback(
    async (index, orderSet) => {
      const data = ordersSets[orderSet].ordens[index];

      const newActiveOrdem = {
        data,
        index,
      };

      console.log("FINANCEIRO:::", data);
      console.log("TYPE FILE:::", data.typeFile);

      if (data.typeFile === "CASH_OUT") {
        const date = data.createdAt.split(" ")[0];
        newActiveOrdem.recebimentoOrders = await getRecebimentoOrders(date);
      }

      setActiveOrdem(newActiveOrdem);

      setIsModalOpen(true);
    },
    [ordersSets]
  );

  const loadConciliacao = useCallback(async () => {
    try {
      setLoading(true);

      const params = {
        year,
        month,
      };

      const response = await api.get("admin/ame/conciliation", { params });

      const { vendas, retiradas, estornos, financeiro } = response.data;

      // setVendas(newVendas);
      // setRetiradas(newRetiradas);
      // setEstornos(newEstornos);
      // setFinanceiro(newFinanceiro);

      setOrdersSets({ vendas, retiradas, estornos, financeiro });

      setLoading(false);
    } catch (err) {
      swal("Ops!", "Houve um erro na requisição de conciliação", "error");
    }
  }, [year, month]);

  useEffect(() => {
    loadConciliacao();
  }, [year, month]);

  const generateRelatory = useCallback(async () => {
    try {
      setLoadingRelatory(true);

      const params = {
        year,
        month,
      };

      const { url } = (
        await api.get("admin/ame/conciliation/relatory", { params })
      ).data;

      setRelatoryUrl(url);
      setLoadingRelatory(false);
    } catch (err) {
      console.error(err);
    }
  }, [year, month]);

  const handleYear = (e) => {
    const { value } = e.target;

    setYear(value);
    setRelatoryUrl("");
  };

  const handleMonth = (e) => {
    const { value } = e.target;

    setMonth(value);
    setRelatoryUrl("");
  };

  return (
    <>
      <AdminMenu />
      <Container>
        <select value={year} onChange={handleYear}>
          <option value="2021">2021</option>
        </select>

        <select value={month} onChange={handleMonth}>
          <option value="01">Janeiro</option>
          <option value="02">Fevereiro</option>
          <option value="03">Março</option>
          <option value="04">Abril</option>
          <option value="05">Maio</option>
          <option value="06">Junho</option>
          <option value="07">Julho</option>
          <option value="08">Agosto</option>
          <option value="09">Setembro</option>
          <option value="10">Outubro</option>
          <option value="11">Novembro</option>
          <option value="12">Dezembro</option>
        </select>

        <button onClick={generateRelatory}>Gerar Relatório deste mês</button>

        {loadingRelatory && !relatoryUrl && <Loading />}

        {relatoryUrl && (
          <a download href={relatoryUrl}>
            Link do Relatório
          </a>
        )}

        {loading ? (
          <Loader />
        ) : (
          <Tabs onSelect={handleChangeAba}>
            <TabList>
              {Object.keys(tabs).map((key) => (
                <Tab>{tabs[key]}</Tab>
              ))}
            </TabList>
            {[
              <TabPanel>
                <h2>
                  Total Bruto: R$
                  {(ordersSets.financeiro.total.bruto / 100).toFixed(2)} - Total
                  Líquido: R$
                  {(ordersSets.financeiro.total.liquido / 100).toFixed(2)}
                </h2>
                <Table>
                  <Table.Header>
                    <Table.Cell>
                      <strong>ID da Ordem</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Nome do cliente</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Data de Criação</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Data de Transação</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Valor da venda</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Valor pago na ordem</strong>
                    </Table.Cell>
                  </Table.Header>
                  <Table.Body>
                    {ordersSets.financeiro.ordens.map((ordem, index) => {
                      const {
                        orderUuid,
                        createdAt,
                        totalAmountInCents,
                        amePedidoJSON,
                        pessoa,
                        liquido,
                      } = ordem;

                      const id = orderUuid;
                      const nome = pessoa?.nome || "";
                      const dataCriacao = new Date(
                        createdAt
                      ).toLocaleDateString("pt-br");
                      const dataAtualizacao = new Date(
                        ordem.transactions[0].updatedAt
                      ).toLocaleDateString("pt-br");

                      const valorTotal = (totalAmountInCents / 100).toFixed(2);
                      const valorLiquido = (liquido / 100).toFixed(2);

                      return (
                        <Table.Row
                          onClick={() => handleOrderSet(index, "financeiro")}
                        >
                          <Table.Cell>{id}</Table.Cell>
                          <Table.Cell>{nome}</Table.Cell>
                          <Table.Cell>{dataCriacao}</Table.Cell>
                          <Table.Cell>{dataAtualizacao}</Table.Cell>
                          <Table.Cell>R${valorTotal}</Table.Cell>
                          <Table.Cell>R${valorLiquido}</Table.Cell>
                        </Table.Row>
                      );
                    })}
                  </Table.Body>
                </Table>
                {aba === "financeiro" && activeOrdem?.data && (
                  <Modal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    style={{
                      content: {
                        // top: "50%",
                        // left: "50%",
                        // right: "40%",
                        // bottom: "auto",
                        // marginRight: "-50%",
                        // transform: "translate(-50%, -50%)",
                        width: "90vw",
                        minWidth: "90vw",
                        maxWidth: "100vw",
                        height: "80vh",
                        minHeight: "max-content",
                      },
                    }}
                  >
                    <div>
                      <h2>
                        Venda: Bruto: R$
                        {(
                          activeOrdem?.data?.venda?.totalAmountInCents / 100
                        ).toFixed(2)}
                        , Líquido: R$
                        {(activeOrdem?.data?.venda?.liquido / 100).toFixed(2)}
                      </h2>

                      <h3>
                        Pedido: {activeOrdem?.data?.amePedidoJSON?.title || ""}
                      </h3>

                      <table>
                        <thead>
                          <tr>
                            <th>ID da transação</th>
                            <th>Data Vencimento</th>
                            <th>Data Atualização</th>
                            <th>Método de Pagamento</th>
                            <th>Parcela Bruta</th>
                            <th>Taxas</th>
                            <th>Parcela Líquida</th>
                            <th>Paga nesta ordem ?</th>
                          </tr>
                        </thead>
                        <tbody>
                          {activeOrdem?.data?.venda.transactions.map(
                            (transaction) => {
                              const {
                                transactionUuid,
                                scheduledFor,
                                updatedAt,
                                paymentMethod,
                                grossAmountInCents,
                                takeRate,
                                netAmountInCents,
                              } = transaction;

                              const inOrder = activeOrdem?.data?.transactions.find(
                                (t) => t.transactionUuid === transactionUuid
                              );

                              const id = transactionUuid;
                              const dataVencimento = new Date(
                                scheduledFor
                              ).toLocaleDateString("pt-br");
                              const dataAtualizacao = inOrder
                                ? new Date(
                                    inOrder.updatedAt
                                  ).toLocaleDateString("pt-br")
                                : "";
                              const metodoPagamento =
                                metodosPagamento[paymentMethod] ||
                                "Indeterminado";

                              const valorBruto = (
                                grossAmountInCents / 100
                              ).toFixed(2);
                              const taxas = (takeRate / 100).toFixed(2);
                              const valorLiquido = (
                                netAmountInCents / 100
                              ).toFixed(2);

                              return (
                                <tr>
                                  <td>{id}</td>
                                  <td>{dataVencimento}</td>
                                  <td>{dataAtualizacao}</td>
                                  <td>{metodoPagamento}</td>
                                  <td>R${valorBruto}</td>
                                  <td>{taxas}%</td>
                                  <td>R${valorLiquido}</td>
                                  <td>
                                    {inOrder ? "Paga nesta ordem" : "NÃO paga"}
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Modal>
                )}
              </TabPanel>,
              <TabPanel>
                <h2>
                  Total Bruto: R$
                  {(ordersSets.retiradas.total.bruto / 100).toFixed(2)} - Total
                  Líquido: R$
                  {(ordersSets.retiradas.total.liquido / 100).toFixed(2)}
                </h2>
                <Table>
                  <Table.Header>
                    <Table.Cell>
                      <strong>ID</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Data Criação</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Data Atualização</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Parcelas</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Valor Bruto</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Valor Líquido</strong>
                    </Table.Cell>
                  </Table.Header>
                  <Table.Body>
                    {ordersSets.retiradas.ordens.map((ordem, index) => {
                      const {
                        orderUuid,
                        createdAt,
                        bruto,
                        liquido,
                        transactions,
                      } = ordem;

                      const id = orderUuid;
                      const dataCriacao = new Date(
                        createdAt
                      ).toLocaleDateString("pt-br");
                      const dataAtualizacao = new Date(
                        transactions[0].updatedAt
                      ).toLocaleDateString("pt-br");

                      const valorBruto = (bruto / 100).toFixed(2);
                      const valorLiquido = (liquido / 100).toFixed(2);
                      const parcelas = transactions.length;

                      return (
                        <>
                          <Table.Row
                            onClick={() => handleOrderSet(index, "retiradas")}
                          >
                            <Table.Cell>{id}</Table.Cell>
                            <Table.Cell>{dataCriacao}</Table.Cell>
                            <Table.Cell>{dataAtualizacao}</Table.Cell>
                            <Table.Cell>R${valorBruto}</Table.Cell>
                            <Table.Cell>R${valorLiquido}</Table.Cell>
                            <Table.Cell>{parcelas}</Table.Cell>
                          </Table.Row>
                        </>
                      );
                    })}
                  </Table.Body>
                </Table>
                {aba === "retiradas" && activeOrdem?.data && (
                  <Modal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    style={{
                      content: {
                        width: "90vw",
                        minWidth: "90vw",
                        maxWidth: "100vw",
                        height: "80vh",
                        minHeight: "max-content",
                      },
                    }}
                  >
                    <div>
                      <h2>
                        Venda: Bruto: R$
                        {(activeOrdem?.data?.totalAmountInCents / 100).toFixed(
                          2
                        )}
                        , Líquido: R$
                        {(activeOrdem?.data?.liquido / 100).toFixed(2)}
                      </h2>

                      <table>
                        <thead>
                          <tr>
                            <th>ID da transação</th>
                            <th>Data Atualização</th>
                            <th>Método de Pagamento</th>
                            <th>Banco</th>
                            <th>Agência</th>
                            <th>Número</th>
                            <th>Parcela Bruta</th>
                            <th>Parcela Líquida</th>
                          </tr>
                        </thead>
                        <tbody>
                          {activeOrdem?.data?.transactions.map(
                            (transaction) => {
                              const {
                                transactionUuid,
                                updatedAt,
                                paymentMethod,
                                grossAmountInCents,
                                takeRate,
                                netAmountInCents,
                                bank,
                                agency,
                                accountNumber,
                              } = transaction;

                              const id = transactionUuid;

                              const dataAtualizacao = new Date(
                                updatedAt
                              ).toLocaleDateString("pt-br");
                              const metodoPagamento =
                                metodosPagamento[paymentMethod] ||
                                "Indeterminado";

                              const valorBruto = (
                                grossAmountInCents / 100
                              ).toFixed(2);
                              const taxas = (takeRate / 100).toFixed(2);
                              const valorLiquido = (
                                netAmountInCents / 100
                              ).toFixed(2);

                              return (
                                <tr>
                                  <td>{id}</td>
                                  <td>{dataAtualizacao}</td>
                                  <td>{metodoPagamento}</td>
                                  <td>{bank}</td>
                                  <td>{agency}</td>
                                  <td>{accountNumber}</td>
                                  <td>R${valorBruto}</td>
                                  <td>R${valorLiquido}</td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>

                      <br />
                      <br />

                      <h2>Transações associadas</h2>
                      <h3>
                        Total Bruto: R$
                        {(
                          activeOrdem?.recebimentoOrders?.reduce(
                            (sum, transaction) =>
                              sum + (transaction?.grossAmountInCents || 0),
                            0
                          ) / 100
                        ).toFixed(2)}
                        ; Total Líquido: R$
                        {(
                          activeOrdem?.recebimentoOrders?.reduce(
                            (sum, transaction) =>
                              sum + (transaction?.netAmountInCents || 0),
                            0
                          ) / 100
                        ).toFixed(2)}
                      </h3>

                      <table>
                        <thead>
                          <tr>
                            <th>ID da transação</th>
                            <th>Nome</th>
                            <th>Data Criação</th>
                            <th>Data Atualização</th>
                            <th>Parcela</th>
                            <th>Valor Bruto</th>
                            <th>Taxas</th>
                            <th>Valor Líquido</th>
                          </tr>
                        </thead>
                        <tbody>
                          {activeOrdem?.recebimentoOrders?.map(
                            (transaction) => {
                              const {
                                transactionUuid,
                                createdAt,
                                updatedAt,
                                grossAmountInCents,
                                takeRate,
                                netAmountInCents,
                                parcela,
                                pessoa,
                                amePedidoJSON,
                              } = transaction;

                              const id = transactionUuid;

                              const dataCriacao = new Date(
                                createdAt
                              ).toLocaleDateString("pt-br");

                              const dataAtualizacao = new Date(
                                updatedAt
                              ).toLocaleDateString("pt-br");

                              const valorBruto = (
                                grossAmountInCents / 100
                              ).toFixed(2);
                              const taxas = (takeRate / 100).toFixed(2);
                              const valorLiquido = (
                                netAmountInCents / 100
                              ).toFixed(2);

                              const nome = pessoa?.nome || "";

                              const pedido = amePedidoJSON?.title || "";

                              return (
                                <tr>
                                  <td>{id}</td>
                                  <td>{nome}</td>
                                  <td>{pedido}</td>
                                  <td>{dataCriacao}</td>
                                  <td>{dataAtualizacao}</td>
                                  <td>{parcela}</td>
                                  <td>R${valorBruto}</td>
                                  <td>{taxas}%</td>
                                  <td>R${valorLiquido}</td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Modal>
                )}
              </TabPanel>,
              <TabPanel>
                <h2>
                  Total Bruto: R$
                  {(ordersSets.vendas.total.bruto / 100).toFixed(2)} - Total
                  Líquido: R$
                  {(ordersSets.vendas.total.liquido / 100).toFixed(2)}
                </h2>
                <Table>
                  <Table.Header>
                    <Table.Cell>
                      <strong>ID da transação</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Pessoa</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Pedido</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Data Criação</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Parcelas</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Valor Bruto</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Valor Líquido</strong>
                    </Table.Cell>
                  </Table.Header>
                  <Table.Body>
                    {ordersSets.vendas.ordens.map((ordem, index) => {
                      const {
                        orderUuid,
                        createdAt,
                        amePedidoJSON,
                        transactions,
                        pessoa,
                        liquido,
                        bruto,
                      } = ordem;

                      const id = orderUuid;
                      const dataCriacao = new Date(
                        createdAt
                      ).toLocaleDateString("pt-br");

                      const { nome } = pessoa || {};
                      const { title: pedido } = amePedidoJSON || {};

                      const parcelas = transactions.length;

                      const valorBruto = (bruto / 100).toFixed(2);
                      const valorLiquido = (liquido / 100).toFixed(2);

                      return (
                        <Table.Row
                          onClick={() => handleOrderSet(index, "vendas")}
                        >
                          <Table.Cell>{id}</Table.Cell>
                          <Table.Cell>{nome}</Table.Cell>
                          <Table.Cell>{pedido}</Table.Cell>
                          <Table.Cell>{dataCriacao}</Table.Cell>
                          <Table.Cell>{parcelas}</Table.Cell>
                          <Table.Cell>R${valorBruto}</Table.Cell>
                          <Table.Cell>R${valorLiquido}</Table.Cell>
                        </Table.Row>
                      );
                    })}
                  </Table.Body>
                </Table>
                {aba === "vendas" && activeOrdem?.data && (
                  <Modal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    style={{
                      content: {
                        width: "90vw",
                        minWidth: "90vw",
                        maxWidth: "100vw",
                        height: "80vh",
                        minHeight: "max-content",
                      },
                    }}
                  >
                    <div>
                      <h2>
                        Venda: Bruto: R$
                        {(activeOrdem?.data?.totalAmountInCents / 100).toFixed(
                          2
                        )}
                        , Líquido: R$
                        {(activeOrdem?.data?.liquido / 100).toFixed(2)}
                      </h2>

                      <h3>
                        Pedido: {activeOrdem?.data?.amePedidoJSON?.title || ""}
                      </h3>

                      <table>
                        <thead>
                          <tr>
                            <th>ID da transação</th>
                            <th>Data Vencimento</th>
                            <th>Data Atualização</th>
                            <th>Método de Pagamento</th>
                            <th>Parcela Bruta</th>
                            <th>Taxas</th>
                            <th>Parcela Líquida</th>
                            <th>Paga nesta ordem ?</th>
                          </tr>
                        </thead>
                        <tbody>
                          {activeOrdem?.data?.transactions.map(
                            (transaction) => {
                              const {
                                transactionUuid,
                                scheduledFor,
                                updatedAt,
                                paymentMethod,
                                grossAmountInCents,
                                takeRate,
                                netAmountInCents,
                              } = transaction;

                              const inOrder = activeOrdem?.data?.transactions.find(
                                (t) => t.transactionUuid === transactionUuid
                              );

                              const id = transactionUuid;
                              const dataVencimento = new Date(
                                scheduledFor
                              ).toLocaleDateString("pt-br");
                              const dataAtualizacao = inOrder
                                ? new Date(
                                    inOrder.updatedAt
                                  ).toLocaleDateString("pt-br")
                                : "";
                              const metodoPagamento =
                                metodosPagamento[paymentMethod] ||
                                "Indeterminado";

                              const valorBruto = (
                                grossAmountInCents / 100
                              ).toFixed(2);
                              const taxas = (takeRate / 100).toFixed(2);
                              const valorLiquido = (
                                netAmountInCents / 100
                              ).toFixed(2);

                              return (
                                <tr>
                                  <td>{id}</td>
                                  <td>{dataVencimento}</td>
                                  <td>{dataAtualizacao}</td>
                                  <td>{metodoPagamento}</td>
                                  <td>R${valorBruto}</td>
                                  <td>{taxas}%</td>
                                  <td>R${valorLiquido}</td>
                                  <td>
                                    {inOrder ? "Paga nesta ordem" : "NÃO paga"}
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Modal>
                )}
              </TabPanel>,
              <TabPanel>
                <h2>
                  Total: R$
                  {(ordersSets.estornos.total.liquido / 100).toFixed(2)}
                </h2>
                <Table>
                  <Table.Header>
                    <Table.Cell>
                      <strong>ID da transação</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Pessoa</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Pedido</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Data</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <strong>Valor</strong>
                    </Table.Cell>
                  </Table.Header>
                  <Table.Body>
                    {ordersSets.estornos.ordens.map((ordem, index) => {
                      const {
                        orderUuid,
                        createdAt,
                        amePedidoJSON,
                        pessoa,
                        liquido,
                      } = ordem;

                      const { nome } = pessoa || {};
                      const { title: pedido } = amePedidoJSON || {};

                      const id = orderUuid;
                      const dataCriacao = new Date(
                        createdAt
                      ).toLocaleDateString("pt-br");

                      const valorLiquido = (liquido / 100).toFixed(2);

                      return (
                        <Table.Row
                          onClick={() => handleOrderSet(index, "estornos")}
                        >
                          <Table.Cell>{id}</Table.Cell>
                          <Table.Cell>{nome}</Table.Cell>
                          <Table.Cell>{pedido}</Table.Cell>
                          <Table.Cell>{dataCriacao}</Table.Cell>
                          <Table.Cell>R${valorLiquido}</Table.Cell>
                        </Table.Row>
                      );
                    })}
                  </Table.Body>
                  {aba === "estornos" && activeOrdem?.data && (
                    <Modal
                      isOpen={isModalOpen}
                      onRequestClose={() => setIsModalOpen(false)}
                      style={{
                        content: {
                          width: "90vw",
                          minWidth: "90vw",
                          maxWidth: "100vw",
                          height: "80vh",
                          minHeight: "max-content",
                        },
                      }}
                    >
                      <div>
                        <h2>
                          Venda: Bruto: R$
                          {(
                            activeOrdem?.data?.venda?.totalAmountInCents / 100
                          ).toFixed(2)}
                          , Líquido: R$
                          {(activeOrdem?.data?.venda?.liquido / 100).toFixed(2)}
                        </h2>

                        <h3>
                          Pedido:{" "}
                          {activeOrdem?.data?.amePedidoJSON?.title || ""}
                        </h3>

                        <table>
                          <thead>
                            <tr>
                              <th>ID da transação</th>
                              <th>Data Vencimento</th>
                              <th>Data Atualização</th>
                              <th>Método de Pagamento</th>
                              <th>Parcela Bruta</th>
                              <th>Taxas</th>
                              <th>Parcela Líquida</th>
                              <th>Paga nesta ordem ?</th>
                            </tr>
                          </thead>
                          <tbody>
                            {activeOrdem?.data?.venda.transactions.map(
                              (transaction) => {
                                const {
                                  transactionUuid,
                                  scheduledFor,
                                  paymentMethod,
                                  grossAmountInCents,
                                  takeRate,
                                  netAmountInCents,
                                } = transaction;

                                const inOrder = activeOrdem?.data?.transactions.find(
                                  (t) => t.transactionUuid === transactionUuid
                                );

                                const id = transactionUuid;
                                const dataVencimento = new Date(
                                  scheduledFor
                                ).toLocaleDateString("pt-br");
                                const dataAtualizacao = inOrder
                                  ? new Date(
                                      inOrder.updatedAt
                                    ).toLocaleDateString("pt-br")
                                  : "";
                                const metodoPagamento =
                                  metodosPagamento[paymentMethod] ||
                                  "Indeterminado";

                                const valorBruto = (
                                  grossAmountInCents / 100
                                ).toFixed(2);
                                const taxas = (takeRate / 100).toFixed(2);
                                const valorLiquido = (
                                  netAmountInCents / 100
                                ).toFixed(2);

                                return (
                                  <tr>
                                    <td>{id}</td>
                                    <td>{dataVencimento}</td>
                                    <td>{dataAtualizacao}</td>
                                    <td>{metodoPagamento}</td>
                                    <td>R${valorBruto}</td>
                                    <td>{taxas}%</td>
                                    <td>R${valorLiquido}</td>
                                    <td>
                                      {inOrder && "Estornada nesta ordem"}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Modal>
                  )}
                </Table>
              </TabPanel>,
            ]}
          </Tabs>
        )}
      </Container>
    </>
  );
};

export default AmeConciliacao;
